import * as AUTH_API from 'cd-eft/services/eftAuthenApi'
import * as CLEAN_API from 'cd-eft/services/eftCleanApi'
import * as HYDRO_API from 'cd-eft/services/eftEfh2Api'
import * as PROJ_API from 'cd-eft/services/eftPrjAdminApi'
import * as SURF_API from 'cd-eft/services/eftSetApi'

import { observable } from 'mobx';


export class DiagnosticVM {
    constructor() { }


    @observable auth_available?: string
    @observable auth_profile?: string
    @observable auth_name?: string
    @observable auth_version?: string

    @observable clean_available?: string
    @observable clean_profile?: string
    @observable clean_name?: string
    @observable clean_version?: string
    @observable clean_core_name?: string
    @observable clean_core_version?: string

    @observable hydro_available?: string
    @observable hydro_profile?: string
    @observable hydro_name?: string
    @observable hydro_version?: string
    @observable hydro_core_name?: string
    @observable hydro_core_version?: string

    @observable proj_available?: string
    @observable proj_profile?: string
    @observable proj_name?: string
    @observable proj_version?: string
    @observable proj_core_name?: string
    @observable proj_core_version?: string

    @observable surf_available?: string
    @observable surf_profile?: string
    @observable surf_name?: string
    @observable surf_version?: string
    @observable surf_core_name?: string
    @observable surf_core_version?: string
    @observable surf_framework_name?: string
    @observable surf_framework_version?: string

    public async initialize() {
        try {
            this.auth_available = await (await AUTH_API.ServiceStatusController.healthCheckUsingGET()).data;
        } catch (ex) {
            this.auth_available = "ERROR"
        }
        try {
            this.auth_profile = await (await AUTH_API.ServiceStatusController.profileCheckUsingGET()).data;
        } catch (ex) {
            this.auth_profile = "ERROR"
        }
        try {
            this.auth_name = await (await AUTH_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.auth_name = "ERROR"
        }
        try {
            this.auth_version = await (await AUTH_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.auth_version = "ERROR"
        }



        try {
            this.clean_available = await (await CLEAN_API.ServiceStatusController.healthCheckUsingGET()).data;
        } catch (ex) {
            this.clean_available = "ERROR"
        }
        try {
            this.clean_profile = await (await CLEAN_API.ServiceStatusController.profileCheckUsingGET()).data;
        } catch (ex) {
            this.clean_profile = "ERROR"
        }
        try {
            this.clean_name = await (await CLEAN_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.clean_name = "ERROR"
        }
        try {
            this.clean_version = await (await CLEAN_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.clean_version = "ERROR"
        }
        try {
            this.clean_core_name = await (await CLEAN_API.ServiceStatusController.manifestCheckCoreUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.clean_core_name = "ERROR"
        }
        try {
            this.clean_core_version = await (await CLEAN_API.ServiceStatusController.manifestCheckCoreUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.clean_core_version = "ERROR"
        }



        try {
            this.hydro_available = await (await HYDRO_API.ServiceStatusController.healthCheckUsingGET()).data;
        } catch (ex) {
            this.hydro_available = "ERROR"
        }
        try {
            this.hydro_profile = await (await HYDRO_API.ServiceStatusController.profileCheckUsingGET()).data;
        } catch (ex) {
            this.hydro_profile = "ERROR"
        }
        try {
            this.hydro_name = await (await HYDRO_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.hydro_name = "ERROR"
        }
        try {
            this.hydro_version = await (await HYDRO_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.hydro_version = "ERROR"
        }
        try {
            this.hydro_core_name = await (await HYDRO_API.ServiceStatusController.manifestCheckCoreUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.hydro_core_name = "ERROR"
        }
        try {
            this.hydro_core_version = await (await HYDRO_API.ServiceStatusController.manifestCheckCoreUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.hydro_core_version = "ERROR"
        }


        try {
            this.proj_available = await (await PROJ_API.ServiceStatusController.healthCheckUsingGET()).data;
        } catch (ex) {
            this.proj_available = "ERROR"
        }
        try {
            this.proj_profile = await (await PROJ_API.ServiceStatusController.profileCheckUsingGET()).data;
        } catch (ex) {
            this.proj_profile = "ERROR"
        }
        try {
            this.proj_name = await (await PROJ_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.proj_name = "ERROR"
        }
        try {
            this.proj_version = await (await PROJ_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.proj_version = "ERROR"
        }
        try {
            this.proj_core_name = await (await PROJ_API.ServiceStatusController.manifestCheckCoreUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.proj_core_name = "ERROR"
        }
        try {
            this.proj_core_version = await (await PROJ_API.ServiceStatusController.manifestCheckCoreUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.proj_core_version = "ERROR"
        }


        try {
            this.surf_available = await (await SURF_API.ServiceStatusController.healthCheckUsingGET()).data;
        } catch (ex) {
            this.surf_available = "ERROR"
        }
        try {
            this.surf_profile = await (await SURF_API.ServiceStatusController.profileCheckUsingGET()).data;
        } catch (ex) {
            this.surf_profile = "ERROR"
        }
        try {
            this.surf_name = await (await SURF_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.surf_name = "ERROR"
        }
        try {
            this.surf_version = await (await SURF_API.ServiceStatusController.manifestCheckUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.surf_version = "ERROR"
        }
        try {
            this.surf_core_name = await (await SURF_API.ServiceStatusController.manifestCheckCoreUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.surf_core_name = "ERROR"
        }
        try {
            this.surf_core_version = await (await SURF_API.ServiceStatusController.manifestCheckCoreUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.surf_core_version = "ERROR"
        }
        try {
            this.surf_framework_name = await (await SURF_API.ServiceStatusController.manifestCheckFrameworkUsingGET()).data.split("Implementation-Title: ")[1].split("\n")[0];
        } catch (ex) {
            this.surf_framework_name = "ERROR"
        }
        try {
            this.surf_framework_version = await (await SURF_API.ServiceStatusController.manifestCheckFrameworkUsingGET()).data.split("Implementation-Version: ")[1].split("\n")[0];
        } catch (ex) {
            this.surf_framework_version = "ERROR"
        }


    }
}